// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.address.RentalManagerUserPropertyAddressV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyAddressUpdateRequestDto, UserPropertyAddressUpdateV2ResponseWebDto } from '../..';

export const RentalManagerUserPropertyAddressV2WebApiHandler_update_Path =
  '/api/web/v2/users/properties/address/update';

/**
 * Update address for property
 */
export const RentalManagerUserPropertyAddressV2WebApiHandler_update = (
  postData: UserPropertyAddressUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyAddressUpdateRequestDto, UserPropertyAddressUpdateV2ResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyAddressV2WebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
